import React from 'react';
import { CreateCategoryState } from './createCategoryState/CreateCategoryState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const CreateCategoryPageV2: React.FC = () => {
	return (
		<CreateCategoryState>
			<Forms />
			<ModalWindows />
		</CreateCategoryState>
	);
};
